import { render, staticRenderFns } from "./Skelton.vue?vue&type=template&id=2b5b5658&"
import script from "./Skelton.vue?vue&type=script&lang=js&"
export * from "./Skelton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports